import { FC } from "react";
import { useParams } from "react-router-dom";
import { AuthenticatedLayout } from "../../layouts";
import EmployeeImportLayout from "../../components/EmployeeImportLayout/EmployeeImportLayout";

export interface IEmployeeImportPage {}
export const EmployeeImportPage: FC<IEmployeeImportPage> = () => {
  return (
    <AuthenticatedLayout
      pageTitle={`Import Employee`}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: `Employee`, navigateTo: `/employee/import` }
      ]}
      mainContents={<EmployeeImportLayout />}
    />
  );
};
